module.exports = __webpack_public_path__ + "static/media/checkgreen.6aeccc34.svg";